export const intlNumberFormat = (number: number) =>
  new Intl.NumberFormat("ru-RU").format(number);
